// extracted by mini-css-extract-plugin
export default {"container":"wJ-z","dimension":"xJ-z","dimensionLabels":"yJ-z"};